export const BOTTOM_NAVIGATION = "BOTTOM_NAVIGATION";
export const SET_HOTEL = "SET_HOTEL";
export const LOAD_GUEST_BOOK = "LOAD_GUEST_BOOK";
export const SET_ACTIVE_GUEST_BOOK = "SET_ACTIVE_GUEST_BOOK";
export const SET_DINE = "SET_DINE";
export const SET_NEAR_BY = "SET_NEAR_BY";
export const SET_ACTIVE_ROUTE = "SET_ACTIVE_ROUTE";
export const SET_TITLE = "SET_TITLE";
export const SET_OFFERS = "SET_OFFERS";
export const SET_COVID_INFO = "SET_COVID_INFO";